import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { Pizzeria } from '../types';

interface PizzeriaCardProps {
  pizzeria: Pizzeria;
}

export default function PizzeriaCard({ pizzeria }: PizzeriaCardProps) {
  const [visiblePizzasCount, setVisiblePizzasCount] = useState(0);

  useEffect(() => {
    const loadPizzasCount = async () => {
      try {
        // Prima controlliamo se ci sono pizze nel menu dinamico
        const menuRef = collection(db, 'pizzeinmenu');
        const q = query(
          menuRef, 
          where('pizzeriaId', '==', pizzeria.id),
          where('isHidden', '==', false)
        );
        const menuSnapshot = await getDocs(q);

        if (menuSnapshot.size > 0) {
          // Se ci sono pizze nel menu dinamico, usiamo quel conteggio
          setVisiblePizzasCount(menuSnapshot.size);
        } else {
          // Altrimenti usiamo il conteggio delle pizze statiche
          const staticCount = pizzeria.pizzas.filter(
            pizzaId => !pizzeria.hiddenPizzas?.includes(pizzaId)
          ).length;
          setVisiblePizzasCount(staticCount);
        }
      } catch (error) {
        console.error('Errore nel conteggio delle pizze:', error);
        // In caso di errore, usiamo il conteggio statico come fallback
        const staticCount = pizzeria.pizzas.filter(
          pizzaId => !pizzeria.hiddenPizzas?.includes(pizzaId)
        ).length;
        setVisiblePizzasCount(staticCount);
      }
    };

    loadPizzasCount();
  }, [pizzeria.id, pizzeria.pizzas, pizzeria.hiddenPizzas]);

  return (
    <Link to={`/pizzerie/${pizzeria.id}`} className="block">
      <div className="bg-white rounded-lg shadow-md overflow-hidden transition-transform hover:scale-105">
        <img
          src={pizzeria.imageUrl}
          alt={pizzeria.name}
          className="w-full h-48 object-cover"
        />
        <div className="p-4">
          <h3 className="text-lg font-semibold text-gray-900">{pizzeria.name}</h3>
          <p className="mt-1 text-gray-600 text-sm">
            {pizzeria.city}
          </p>
          <p className="mt-1 text-gray-600 text-sm line-clamp-2">
            {pizzeria.description}
          </p>
          <div className="mt-2">
            <p className="text-sm text-gray-500">
              {visiblePizzasCount} {visiblePizzasCount === 1 ? 'pizza disponibile' : 'pizze disponibili'}
            </p>
          </div>
        </div>
      </div>
    </Link>
  );
}